module.exports = __webpack_public_path__ + "static/media/sample-products-csv.573aa7f5.csv";